function modulePageHero(){

	$('.slider-wrapper:not(.triple):not(.double)').slick({
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnHover: false,
		pauseOnFocus: false,
		dots: true
	});

	$('.slider-wrapper.triple').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnHover: false,
		pauseOnFocus: false,
		dots: true,
		responsive: [
			{
				breakpoint: 1260,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: true,
					autoplaySpeed: 5000,
					pauseOnHover: false,
					pauseOnFocus: false,
					dots: true
				}
			}
		]
	});

	if (window.innerWidth >= 1260) {
		$('.slider-wrapper.double').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,
			pauseOnHover: false,
			pauseOnFocus: false,
			dots: true
		});
	}

	if($('.mph__custom-code #video')){

		/* Disclaimer for future Devs trying to find the youtube API code */
		////////////////////////////////////////////////////////////////////
		/* Code is located in page_hero.php because YT are dumb, and can't */
		/* call their function if it is inside another function :((        */
	}

    $("#vf_vacancies_button").on("click",function (e) {
    	e.preventDefault();

    	var offset = $('header.header').outerHeight() - 70;

        $("html,body").animate({
            scrollTop: $(".m__vf-smart-feed").offset().top - offset,
        }, 750);
    });	
}
